import * as React from "react";
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import Main from "../main/main";
import EInvoice from "../einvoice/EInvoice";
import Helmet from "react-helmet/es/Helmet";

class App extends React.Component {
    constructor(props) {
        super(props);
        this.franchiseData = this.props.franchiseData;
        this.siteConfigData = this.props.siteConfigData;
        this.isSwapSite = this.props.isSwapSite;
    }

    helmetReturnChoice = () => {
        let helmetReturn = '';
        if (this.isSwapSite === true) {
            helmetReturn = '<Helmet><meta content="text/html" charset="UTF-8" http-equiv="content-type" /><meta name="viewport" content="width=device-width, initial-scale=1"/><meta name="theme-color" content="#000000"/><link href="//cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"  rel="stylesheet"/><link href="//stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css" rel="stylesheet"/></Helmet>';
        } else {
            helmetReturn = '<Helmet><meta charSet="utf-8"/><meta name="viewport" content="width=device-width, initial-scale=1"/><meta name="theme-color" content="#000000"/><link rel="manifest" href="%PUBLIC_URL%/manifest.json"/><link rel="stylesheet" type="text/css" href="/images/hbapp/css/MENUstyle.css"/><link rel="stylesheet" href="/images/home-based/Bootstrap/css/font-awesome.min.css"/></Helmet>';
        }
        return helmetReturn;
    }

    render() {
        return (
            <div>
                {this.isSwapSite && <Helmet>
                	<meta content="text/html" charset="UTF-8" http-equiv="content-type" />
                    <meta name="viewport" content="width=device-width, initial-scale=1"/>
                    <meta name="theme-color" content="#000000"/>
                    <link href="//cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"  rel="stylesheet"/>
                    <link href="//stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css" rel="stylesheet"/>
                </Helmet>
                }
                {!this.isSwapSite &&
                <Helmet>
                    <meta charSet="utf-8"/>
                    <meta name="viewport" content="width=device-width, initial-scale=1"/>
                    <meta name="theme-color" content="#000000"/>
                    <link rel="stylesheet" type="text/css" href="/images/hbapp/css/MENUstyle.css"/>
                    <link rel="stylesheet" href="/images/home-based/Bootstrap/css/font-awesome.min.css"/>
                </Helmet>
                }
                <Router basename="/customer-self-service/">
                    <Switch>
                        <Route exact path="/">
                            <Main franchiseData={this.franchiseData} siteConfigData={this.siteConfigData} isSwapSite={this.isSwapSite} activeComponentInMain="verification"/>
                        </Route>
                        <Route path="/einvoice/:enc">
                            <EInvoice franchiseData={this.franchiseData}/>
                        </Route>
                        {/*<Route>
                            <Redirect to="/"/>
                        </Route>*/}
                    </Switch>
                </Router>
            </div>
        )
    }
}

export default App
